<template>
    <div id="app">
        <!-- <div v-if="go_new" class="go-new">
            <p>地址更新，<span>{{num}}</span>秒后跳转到新地址...</p>
        </div> -->
        <router-view></router-view>

        <serviceFee :isShow="serviceFee_isShow" :data="total_money_serviceFee"></serviceFee>
        <newNotice :isShow="newNotice_isShow"></newNotice>
        <privateno :isShow="privateno_isShow" :data="total_money_privateno"></privateno>
        <annualFee :isShow="annualFee_isShow" :data="total_money_annualFee"></annualFee>
        <!-- 司机预警弹窗 -->
        <alertMessage :isShow="alert_show" :data="content"></alertMessage>
    </div>
</template>

<script>
import axios from 'axios'; // AJAX封装类
import { config } from './utils/config'; //配置
import bus from './components/common/bus.js';
import serviceFee from './components/common/serviceFee.vue';
import newNotice from './components/common/newNotice.vue';
import privateno from './components/common/privateno.vue';
import annualFee from './components/common/annualFee.vue';
import alertMessage from '@/components/page/city/driverAlert/alertMessage';

import vHead from './components/common/Header';
import vSidebar from './components/common/Sidebar';
import vTags from './components/common/Tags'; // AJAX封装类
var _this;
export default {
    components: {
        serviceFee,
        newNotice,
        privateno,
        annualFee,
        alertMessage
    },

    data() {
        return {
            content: '',
            audio: '',
            driver_alert_code: '',
            myTimer: '',
            alert_show: false,
            serviceFee_isShow: false,
            newNotice_isShow: false,
            privateno_isShow: false,
            annualFee_isShow: false,
            total_money_annualFee: '',

            total_money_serviceFee: '',
            total_money_privateno: '',
            search_data_notify: {
                page: 1,
                limit: 5
            }
        };
    },

    created() {
        _this = this;

        // axios.defaults.baseURL = config.axios_normalURL;
        // // 高德语音播报token
        // _this
        //     .$post('/system/getBaiduOpenToken')
        //     .then((res) => {
        //         localStorage.setItem('bdToken', res.data.access_token);
        //     })
        //     .catch((err) => {});
        // axios.defaults.baseURL = config.axios_baseURL; //请求base url

        // 获取当前地址
        var oldHref = window.location.href;
        // console.log(oldHref.slice(14, 16));

        // 判断当前地址是否为新地址
        // if (oldHref.slice(14, 16) != 'v3') {
        //     this.$message.closeAll(); // 关闭所有已打开的 $message 弹窗
        //     this.$message({
        //         showClose: true,
        //         message: '后台管理系统新地址:https://admin.v3.jiuzhoudaijiaapi.cn/',
        //         duration: 0
        //     });
        // }

        axios.defaults.baseURL = config.axios_normalURL; //请求normal url
        _this
            .$post('/system/systemTimestamp')
            .then((res) => {
                axios.defaults.baseURL = config.axios_baseURL; //请求base url

                let time_difference = res.data.timestamp - Math.round(new Date() / 1000);

                sessionStorage.setItem('time_difference', time_difference);
            })
            .catch((err) => {});

        axios.defaults.baseURL = config.axios_baseURL; //请求base url

        bus.$on('logIn', (msg) => {
            // 登录后判断是否弹出服务费提醒弹窗
            _this
                .$post('/service_fee/getServiceChargeRemind')
                .then((res) => {
                    if (res.data.is_true == 1) {
                        _this.total_money_serviceFee = res.data.total_money;
                        _this.serviceFee_isShow = !_this.serviceFee_isShow;
                    }
                })
                .catch((err) => {});

            // 根据更新通知是否有新消息来判断是否弹出消息通知弹窗

            _this
                .$post('/notice/adminNoticeLists', _this.search_data_notify)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[0].status == '0') {
                            _this.newNotice_isShow = !_this.newNotice_isShow;
                        }
                    }
                })
                .catch((err) => {});

            // 隐私通话预警通知弹窗

            // _this
            //     .$post('/privateno/getPrivateServiceFeeRemind')
            //     .then((res) => {
            //         if (res.data.is_true == 1) {
            //             _this.total_money_privateno = res.data.total_money;
            //             _this.privateno_isShow = !_this.privateno_isShow;
            //         }
            //     })
            //     .catch((err) => {});

            // 年费预警通知弹窗

            _this
                .$post('/service_fee/getAnnualFeeRemind')
                .then((res) => {
                    if (res.data.is_true == 1) {
                        _this.total_money_annualFee = res.data.total_money;
                        _this.annualFee_isShow = !_this.privateno_isShow;
                    }
                })
                .catch((err) => {});
        });
    },
    mounted() {
        // console.log(_this.content, 'this.content===');
        // console.log( _this.alert_show);
        // _this.alert_show = !_this.alert_show;
        // 如果放在created中，第一次进入页面时会先执行App.vue里面的created，再执行Login.vue登录页面created里面的 localStorage.removeItem('access_token');就会导致下面的问题
        // 如果用户登录后不点击退出登录按钮，那么token就不会清除，登录页面执行当前代码，token存在，就会执行接口，然后就会在登录页面弹出弹窗
        // let token = localStorage.getItem('access_token');
        // console.log(token, 'token-app.vue');

        // if (token) {
        //     _this.getAlert();
        // } else {
        //     _this.clearAlertTimer();
        // }

        if (this.$route.path == '/login' || this.$route.path == '/') {
            console.log('路由是登录页面则清除司机预警定时器');

            _this.clearAlertTimer();
        } else {
            console.log('路由不是登录页面则执行定时器');

            _this.getAlert();
        }

        // 退出登录后清除定时器
        bus.$on('clear-alert-timer', () => {
            console.log('退出登录清除定时器');

            _this.driver_alert_code = '';

            _this.clearAlertTimer();
        });
        // 司机消息提醒弹窗 登录后触发
        bus.$on('getMessage', () => {
            console.log('登录触发弹窗提醒');

            _this.getAlert();
        });
        // 司机预警弹窗页面点击忽略按钮关闭音频文件
        bus.$on('poseMp3', () => {

            // 自动播放音频
            console.log(_this.audio,'app.vue暂停播放方法');
            if (_this.audio) {
            console.log('暂停播放方法');


                _this.audio.pause();
            }
        });
    },
    methods: {
        clearAlertTimer() {
            clearTimeout(this.myTimer);

        },
        getAlert() {

            // _this.clearAlertTimer();

            _this.$post('/alert/driver').then((res) => {
                // 每次只能弹一条消息，读完一条下次轮询就返回另一条
                if (res.data.msg) {
                    // if (_this.driver_alert_code != res.data.driver_alert_code) {
                        _this.alert_show = !_this.alert_show;
                        console.log(_this.alert_show,'_this.alert_show');

                        // _this.driver_alert_code = res.data.driver_alert_code;
                        _this.content = res.data.msg;
                        _this
                            .$post('/alert/getDriverAlertVoice')
                            .then((res) => {

                                if (res.data.driver_alert_voice) {
                                    let recording = res.data.driver_alert_voice;

                                    if (_this.audio!='') {
                                        console.log(_this.audio,'_this.audio');


                                        _this.audio.pause();


                                        // _this.audio.play();

                                        // 循环播放
                                        // _this.audio.onended = function () {
                                        //     _this.audio.play();
                                        // };
                                    }

                                    // 创建一个新的 Audio 对象
                                    _this.audio = new Audio(recording);
                                    _this.audio.play();

                                    // 自动播放音频
                                    // if (_this.audio) {
                                    //     console.log(_this.audio,'_this.audio');


                                    //     _this.audio.pause();


                                    //     // _this.audio.play();

                                    //     // 循环播放
                                    //     // _this.audio.onended = function () {
                                    //     //     _this.audio.play();
                                    //     // };
                                    // } else {

                                    //     _this.audio.play();
                                    //     // 循环播放
                                    //     // _this.audio.onended = function () {
                                    //     //     _this.audio.play();
                                    //     // };
                                    // }
                                }
                            })
                            .catch((err) => {});
                    // }
                }

                _this.myTimer = setTimeout(() => {
                    _this.getAlert();
                }, 10000);
            });

            // this.$driverAlert = setTimeout(() => {
            //     _this.getAlert();
            // }, 3000);

            // console.log(this.$driverAlert, 'this.$driverAlert-app.vue');
        }
    }
};
</script>



<style>
@import './assets/css/main.css';
@import './assets/css/color-dark.css';

.go-new {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%);
    padding: 10px;
    background-color: #ccc;
    border-radius: 10px;
}
.baidu {
    display: none !important;
}
</style>
